import React, { useState, useEffect, useContext } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import Images from "assets/images/imageData";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DivLayout from "components/sales/divLayout/divLayout";
import DocumentView from "components/sales/downloadDocView/documentView";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import DatePicker from "components/sales/datePicker/datePicker";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { toast } from "react-toastify";
import "./update_request.css";
import AssignLocation from "../AssignLocation/AssignLocation";
import AssignReportee from "../AssignReportee/AssignReportee";

const UpdateRequest = ({
  match,
  getoffRoleEmployeesData,
  getEmployeesListing = [],
  getDataForDropdown,
  getDropdownDatas = [],
  updateStatusOffroleEmployee,
  statusUpdationByBusinessHead = [],
  getLocationMappingByUserId,
  getLocationMappingByUserIdResponse = [],
  getTeamMappingByUserId,
  getTeamMappingByUserIdResponse = [],
  citiesDropdownData,
  citiesDropdownResponse = [],
  zonesDropdownData,
  zonesDropdownResponse = [],
  departmentDropdownData,
  departmentDropwdownResponse = [],
  teamDropdownData,
  teamDropdownResponse = [],
  areasDropdownData,
  areasDropdownResponse = [],
  reportingManagerDropdownData,
  reportingManagerResponse = [],
  assignLocationsToUser,
  assignReporteeToUser,
  deleteUserMappingRequest,
  deleteUserMappingResponse = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setData] = useState({
    department_id: "",
    date_of_joining: "",
    city_id: "",
    employee_type: "",
    role_id: "",
    action_remark: "",
    status: "",
    designation_id: "",
    leadx_login_preference: "",
  });
  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [message, setMessage] = useState("");
  const [showAssignLocationPopup, setShowAssignLocationPopup] = useState(false);
  const [showAssignReporteePopup, setShowAssigReporteePopup] = useState(false);
  const [teamId, setTeamId] = useState([]);
  const [deletionModal, setDeletionModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const profileDetails = JSON.parse(localStorage.getItem("profileDetails"));
  const department_id = profileDetails[0]?.department_id;
  const team_id = profileDetails[0]?.team_id;
  const [offroleId, setOffroleId] = useState(null);

  const handleDepartmentChange = async (departmentId) => {
    setIsLoading(true);
    await teamDropdownData(departmentId);
    setIsLoading(false);
  };

  useEffect(() => {
    const storedData = localStorage.getItem("profileDetails");
    if (storedData) {
      const parsed = JSON.parse(storedData);

      if (parsed.length > 0) {
        setTeamId(parsed[0].team_id);
      }
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await getDataForDropdown();
      await getoffRoleEmployeesData(
        1,
        [],
        match?.params?.user_id,
        null,
        "USER"
      );
      await citiesDropdownData();
      await zonesDropdownData();
      await departmentDropdownData();
      handleDepartmentChange(department_id);
      setIsLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (
        getEmployeesListing?.response?.data?.data &&
        getEmployeesListing?.response?.data?.data.length > 0
      ) {
        const details = getEmployeesListing.response.data.data[0];

        setOffroleId(details?.id ?? null);

        setData({
          department_id: details?.department_id || "",
          designation_id: details?.designation_id || "",
          date_of_joining: details?.date_of_joining || "",
          city_id: details?.city_id || "",
          employee_type: details?.employee_type || "",
          role_id: details?.role_id || "",
          leadx_login_preference: details?.leadx_login_preference || "",
          action_remark: "",
        });

        await getLocationMappingByUserId(details?.user_id);
        await getTeamMappingByUserId(details?.user_id);
      }
    };

    fetchData();
  }, [getEmployeesListing]);

  const today = new Date();
  const minDate = new Date(today);
  minDate.setDate(today.getDate() - 2);
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + 2);

  const handleSuccessModalHide = () => {
    setIsSuccessModal(false);
  };

  const handleUpdate = async () => {
    formData["update"] = true;
    formData["id"] = match?.params?.user_id;
    formData["offrole_id"] = offroleId;
    setIsLoading(true);
    const res = await updateStatusOffroleEmployee(formData);
    if (res?.status == 200) {
      setMessage(res?.message);
      setIsSuccessModal(true);
    } else {
      toast.error(res?.message);
    }
    setIsLoading(false);
  };

  const handleDeleteLocationMapping = async (
    userId,
    cityId,
    zoneId,
    areaId
  ) => {
    const payload = {
      user_id: userId,
      city_id: cityId,
      zone_id: zoneId,
      area_id: areaId,
      action: "LOCATION",
    };
    setModalMessage("Delete Location Mapping");
    setIsLoading(true);
    const res = await deleteUserMappingRequest(payload);
    console.log("res: ", res);
    if (res?.status == 200) {
      setDeletionModal(true);
    }
    setIsLoading(false);
  };

  const handleDeleteTeamMapping = async (
    userId,
    departmentId,
    teamId,
    reportingTo = null
  ) => {
    const payload = {
      user_id: userId,
      department_id: departmentId,
      team_id: teamId,
      action: "TEAM",
      reporting_to: reportingTo,
    };
    setModalMessage("Delete Team Mapping");
    setIsLoading(true);
    const res = await deleteUserMappingRequest(payload);
    console.log("res: ", res);
    if (res?.status == 200) {
      setDeletionModal(true);
    }
    setIsLoading(false);
  };

  const handleDeletionModalHide = () => {
    setDeletionModal(false);
  };

  return (
    <Layout title={"Employee Details"} isGoback isLoading={isLoading}>
      {getEmployeesListing?.response?.data?.data?.length > 0 ? (
        getEmployeesListing.response.data.data.map((details, index) =>
          details?.id ? (
            <div key={index} className="panel-card">
              <div
                className="panel-heading"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{localization.employeeDetails}</span>

                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: details?.status_name === "Active" ? "green" : "red",
                    fontWeight: 600,
                  }}
                >
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      backgroundColor:
                        details?.status_name === "Active" ? "green" : "red",
                      display: "inline-block",
                    }}
                  ></span>

                  {details?.status_name ?? localization.na}
                </span>
              </div>

              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.fullName}
                    data={details?.employee_name ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.fathersName}
                    data={details?.employee_father_name ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.dateOfBirth}
                    data={details?.date_of_birth ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.phoneNumber}
                    data={details?.phone_number ?? localization.na}
                  />
                  <DivLayout
                    heading={"Company Email Id"}
                    data={details?.email ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.emergencyContactName}
                    data={details?.emergency_contact_name ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.emergencyContactNumber}
                    data={
                      details?.emergency_contact_phone_number ?? localization.na
                    }
                  />

                  <DivLayout
                    heading={localization.aadharNumber}
                    data={details?.aadhar_number ?? localization.na}
                  />

                  <DivLayout
                    heading={localization.aadharStatus}
                    data={
                      <span
                        style={{
                          color:
                            details?.aadhar_status === "Verified"
                              ? "green"
                              : "red",
                        }}
                      >
                        <b>{details?.aadhar_status ?? localization.na}</b>
                      </span>
                    }
                  />

                  <div className="col-md-12">
                    <div className="col-md-6">
                      {details?.aadhar_document && (
                        <DocumentView
                          title={localization.aadharImage}
                          attachment={details?.aadhar_document}
                        />
                      )}
                    </div>
                    <div className="col-md-6">
                      {details?.pan_document && (
                        <DocumentView
                          title={localization.panImage}
                          attachment={details?.pan_document}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <hr />

                <div className="row mt-3">
                  <div className="col-md-4">
                    <DropDownInput
                      data={getDropdownDatas?.response?.data?.departments}
                      label={localization.department}
                      required
                      getIdValue={(val) => {
                        if (formData.department_id !== val.id) {
                          setData({ ...formData, department_id: val.id });
                        }
                      }}
                      errorMsg={localization.required}
                      isStarRequired={true}
                      getValueById={formData.department_id}
                    />
                  </div>

                  <div className="col-md-4">
                    <DropDownInput
                      data={teamDropdownResponse?.response?.data}
                      label={localization.team}
                      required
                      getIdValue={(val) => {
                        setData({ ...formData, team_id: val.id });
                      }}
                      errorMsg={localization.required}
                      isStarRequired={true}
                      getValueById={teamId}
                    />
                  </div>

                  <div className="col-md-4">
                    <DropDownInput
                      data={getDropdownDatas?.response?.data?.designations}
                      label={localization.designation}
                      required
                      getIdValue={(val) => {
                        if (formData.designation_id !== val.id) {
                          setData({ ...formData, designation_id: val.id });
                        }
                      }}
                      errorMsg={localization.required}
                      isStarRequired={true}
                      getValueById={formData.designation_id}
                    />
                  </div>

                  <div className="col-md-4">
                    <DropDownInput
                      data={getDropdownDatas?.response?.data?.locations}
                      label="Hiring Location"
                      required
                      getIdValue={(val) => {
                        if (formData.city_id !== val.id) {
                          setData({ ...formData, city_id: val.id });
                        }
                      }}
                      errorMsg={localization.required}
                      isStarRequired={true}
                      getValueById={formData.city_id}
                    />
                  </div>

                  <div className="col-md-4">
                    <DropDownInput
                      data={getDropdownDatas?.response?.data?.employee_types}
                      label={localization.employeeType}
                      required
                      getIdValue={(val) => {
                        if (formData.employee_type !== val.id) {
                          setData({ ...formData, employee_type: val.id });
                        }
                      }}
                      errorMsg={localization.required}
                      isStarRequired={true}
                      getValueById={formData.employee_type}
                    />
                  </div>

                  <div className="col-md-4">
                    <DatePicker
                      label={localization.dateOfJoining}
                      required={true}
                      minimumDate={minDate}
                      maxDate={maxDate}
                      defaultValue={formData.date_of_joining}
                      value={details?.date_of_joining}
                      handleChange={(val) => {
                        setData({ ...formData, date_of_joining: val });
                      }}
                    />
                  </div>

                  <div className="col-md-4">
                    <DropDownInput
                      data={[
                        { id: 1, name: "Web" },
                        { id: 2, name: "App" },
                        { id: 3, name: "Both" },
                      ]}
                      label={"LeadX Login Preference"}
                      required
                      getIdValue={(val) => {
                        setData({
                          ...formData,
                          leadx_login_preference: val.id,
                        });
                      }}
                      errorMsg={localization.required}
                      isStarRequired={true}
                      getValueById={formData.leadx_login_preference}
                    />
                  </div>
                </div>

                {details?.status == 3 && (
                  <div className="col-md-12 d-flex mb-4 mt-3">
                    <Button
                      className="btn btn-sm btn-success"
                      onClick={handleUpdate}
                    >
                      Update
                    </Button>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div key={index} className="panel-card">
              <div
                className="panel-heading"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{localization.employeeDetails}</span>

                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color:
                      details?.user_status_name === "Active" ? "green" : "red",
                    fontWeight: 600,
                  }}
                >
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      backgroundColor:
                        details?.user_status_name === "Active"
                          ? "green"
                          : "red",
                      display: "inline-block",
                    }}
                  ></span>

                  {details?.user_status_name ?? localization.na}
                </span>
              </div>

              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.fullName}
                    data={details?.name ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.email}
                    data={details?.email ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.mobileNumber}
                    data={details?.mobile_number ?? localization.na}
                  />
                </div>

                <div className="col-md-4">
                  <DropDownInput
                    data={[
                      { id: 1, name: "Web" },
                      { id: 2, name: "App" },
                      { id: 3, name: "Both" },
                    ]}
                    label={"LeadX Login Preference"}
                    required
                    getIdValue={(val) => {
                      setData({
                        ...formData,
                        leadx_login_preference: val.id,
                      });
                    }}
                    errorMsg={localization.required}
                    isStarRequired={true}
                    getValueById={formData.leadx_login_preference}
                  />
                </div>

                <hr />
                {details?.user_status == 1 && (
                  <div className="col-md-12 d-flex mb-4 mt-3">
                    <Button
                      className="btn btn-sm btn-success"
                      onClick={handleUpdate}
                    >
                      Update
                    </Button>
                  </div>
                )}
              </div>
            </div>
          )
        )
      ) : (
        <div>
          <img src={Images?.NoData} alt="" width="100%" />
        </div>
      )}

      <div className="panel-card">
        <div
          className="panel-heading"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>{"Location Mapping"}</span>

          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontWeight: 600,
            }}
          >
            <Button
              className="btn btn-sm invert-hover"
              style={{ backgroundColor: "white", color: "black" }}
              onClick={() => setShowAssignLocationPopup(true)}
            >
              Assign Location
            </Button>
          </span>
        </div>
        {Array.isArray(getLocationMappingByUserIdResponse?.response?.data) &&
        getLocationMappingByUserIdResponse?.response?.data.length > 0 ? (
          <div className="panel-body">
            <table className="area-table" style={{ textAlign: "center" }}>
              <thead>
                <tr>
                  <th style={{ width: "60px" }}>S.No</th>
                  <th style={{ textAlign: "center" }}>City</th>
                  <th style={{ textAlign: "center" }}>Zone</th>
                  <th style={{ textAlign: "center" }}>Area</th>
                  <th style={{ textAlign: "center" }}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {getLocationMappingByUserIdResponse.response.data.map(
                  (row, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td className="area-name">{row.city_name}</td>
                      <td className="area-name">{row.zone_name}</td>
                      <td className="area-name">{row.area_name ?? "-"}</td>
                      <td>
                        <svg
                          onClick={() =>
                            handleDeleteLocationMapping(
                              getEmployeesListing.response.data.data[0]
                                ?.user_id,
                              row?.city_id,
                              row?.zone_id,
                              row?.area_id
                            )
                          }
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          viewBox="0 0 24 24"
                          style={{ cursor: "pointer" }}
                        >
                          <path d="M3 6l3 18h12l3-18H3zm8 14V10h2v10h-2zm-4 0V10h2v10H7zm10 0h-2V10h2v10zM19 4V2H5v2H2v2h20V4z" />
                        </svg>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div>
            <img src={Images?.NoData} alt="No Data" />
          </div>
        )}
      </div>

      <div className="panel-card">
        <div
          className="panel-heading"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>{"Team Mapping"}</span>

          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontWeight: 600,
            }}
          >
            <Button
              className="btn btn-sm invert-hover"
              style={{ backgroundColor: "white", color: "black" }}
              onClick={() => setShowAssigReporteePopup(true)}
            >
              Assign Team
            </Button>
          </span>
        </div>

        {Array.isArray(getTeamMappingByUserIdResponse?.response?.data) &&
        getTeamMappingByUserIdResponse?.response?.data.length > 0 ? (
          <div className="panel-body">
            <table className="area-table" style={{ textAlign: "center" }}>
              <thead>
                <tr>
                  <th style={{ width: "60px", textAlign: "center" }}>S.No</th>
                  <th style={{ textAlign: "center" }}>Department</th>
                  <th style={{ textAlign: "center" }}>Team</th>
                  <th style={{ textAlign: "center" }}>Reporting To</th>
                  <th style={{ textAlign: "center" }}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {getTeamMappingByUserIdResponse.response.data.map(
                  (row, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td className="area-name">{row.department_name}</td>
                      <td className="area-name">{row.team_name}</td>
                      <td className="area-name">
                        {row.reporting_to_name ?? "-"}
                      </td>
                      <td>
                        <svg
                          onClick={() =>
                            handleDeleteTeamMapping(
                              getEmployeesListing.response.data.data[0]
                                ?.user_id,
                              row?.department_id,
                              row?.team_id,
                              row?.reporting_to
                            )
                          }
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          viewBox="0 0 24 24"
                          style={{ cursor: "pointer" }}
                        >
                          <path d="M3 6l3 18h12l3-18H3zm8 14V10h2v10h-2zm-4 0V10h2v10H7zm10 0h-2V10h2v10zM19 4V2H5v2H2v2h20V4z" />
                        </svg>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div>
            <img src={Images?.NoData} alt="No Data" />
          </div>
        )}
      </div>

      <ModalPop
        title={localization.conf}
        show={isSuccessModal}
        handleModalHide={handleSuccessModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{message}</h5>
          <button
            className="btn btn-primary mb-4"
            onClick={() => window.location.reload()}
          >
            {"Close"} <img src={Images?.ArrowRight} alt="" />
          </button>
        </div>
      </ModalPop>

      <AssignLocation
        showAssignLocationPopup={showAssignLocationPopup}
        onClosePopup={() => setShowAssignLocationPopup(false)}
        locationAssignUserId={
          getEmployeesListing?.response?.data?.data[0]?.user_id
        }
        citiesDropdownResponse={citiesDropdownResponse}
        zonesDropdownResponse={zonesDropdownResponse}
        zonesDropdownData={zonesDropdownData}
        assignLocationsToUser={assignLocationsToUser}
        areasDropdownData={areasDropdownData}
        areasDropdownResponse={areasDropdownResponse}
      />

      <AssignReportee
        showAssignLocationPopup={showAssignReporteePopup}
        onClosePopup={() => setShowAssigReporteePopup(false)}
        locationAssignUserId={
          getEmployeesListing?.response?.data?.data[0]?.user_id
        }
        departmentDropwdownResponse={departmentDropwdownResponse}
        teamDropdownResponse={teamDropdownResponse}
        reportingManagerResponse={reportingManagerResponse}
        departmentId={department_id}
        teamId={team_id}
        reportingToRoleId={
          getEmployeesListing?.response?.data?.data[0]?.role_id
        }
        reportingToRoleLevel={
          getEmployeesListing?.response?.data?.data[0]?.role_level
        }
        reportingManagerDropdownData={reportingManagerDropdownData}
        assignReporteeToUser={assignReporteeToUser}
      />
      <ModalPop
        title={modalMessage}
        show={deletionModal}
        handleModalHide={handleDeletionModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{"Mapping deleted successfully"}</h5>
          <button
            className="btn btn-primary mb-4"
            onClick={() => window.location.reload()}
          >
            {"Close"} <img src={Images?.ArrowRight} alt="" />
          </button>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default UpdateRequest;
